import { useContext, useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { toast } from "react-toastify";
import LoadingDialog from "../Utils/LoadingDialog";
import { ZonesMapTableRow, NodesMapTableRow } from "./Tables";
import { updateMapInfo, GoogleMapsFarm } from "../GoogleMapsFarm/GoogleMapsFarm";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faArrowCircleRight, faArrowCircleLeft, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

import "react-toastify/dist/ReactToastify.css";
import "../Form/FormStyles.css";
import "./FarmInfo.css";

import { FarmContext } from "../../contexts/FarmContext";
import withName from "../../hoc/withName";
import kmlParser from "js-kml-parser";
import SelfHelp from "../Utils/SelfHelp";

import jszip from "jszip";
import ButtonPrime from "../PrimeComponents/ButtonPrime";
import TooltipPrime from "../PrimeComponents/TooltipPrime";
import DropdownPrime from "../PrimeComponents/DropdownPrime";

const getFarm = (location) => {
    const params = new URLSearchParams(location && location.search);
    const farm = params.get("farm");
    return farm;
};

const MapaConfig = ({ dataFarm, mapRef }) => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const [_, dispatch] = useContext(FarmContext);
    const farmId = getFarm(location);
    const sectorsInfo = dispatch({ type: "get", path: "sectors" });
    const nodesInfo = dispatch({ type: "get", path: "nodes" });
    const params = new URLSearchParams(location && location.search);
    const farmblack = params.get("farmblack") || null;
    const [mapaJson, setMapaJson] = useState(null);
    const [uploadedMap, setUploadedMap] = useState(null);
    const [poligonosMarkers, setPoligonosMarkers] = useState(null);
    const [poligonosList, setPoligonosList] = useState(null);
    const [puntosList, setPuntosList] = useState(null);
    const [dataLoading, setDataLoading] = useState(false);
    const [headerText, setHeaderText] = useState([
        { text: t("farms.zonesTable.title") },
        { text: t("farms.nodesTable.title") }
    ]);
    const [sectoresRows, setSectoresRows] = useState(null);
    const [nodosRows, setNodosRows] = useState(null);
    const [pagSectoresRows, setPagSectoresRows] = useState(null);
    const [pagNodosRows, setPagNodosRows] = useState(null);
    const [tabRef, setTabRef] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [showSectoresTab, setShowSectoresTab] = useState(true);
    const [showNodosTab, setShowNodosTab] = useState(false);
    const [maxRows, setMaxRows] = useState(10);
    const [pagNodos, setPagNodos] = useState(1);
    const [pagSectores, setPagSectores] = useState(1);
    const numRows = [{ num: 5 }, { num: 10 }, { num: 15 }, { num: 20 }];
    const visibleMap = useMemo(() => {
        if (dataFarm.mapa_json && dataFarm.mapa_json.configurado) return true;
        return false;
    }, [dataFarm]);

    const selfHelpImg0 = import.meta.glob("../../img/autoayuda/*/autoayuda-mapconfig-0.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-mapconfig-0.png`];
    const selfHelpImg1 = import.meta.glob("../../img/autoayuda/*/autoayuda-mapconfig-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-mapconfig-1.png`];
    const selfHelpImg2 = import.meta.glob("../../img/autoayuda/*/autoayuda-mapconfig-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-mapconfig-2.png`];
    const selfHelpImg3 = import.meta.glob("../../img/autoayuda/*/autoayuda-mapconfig-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-mapconfig-3.png`];
    const selfHelpImg4 = import.meta.glob("../../img/autoayuda/*/autoayuda-mapconfig-4.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-mapconfig-4.png`];
    const selfHelpImg5 = import.meta.glob("../../img/autoayuda/*/autoayuda-mapconfig-5.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-mapconfig-5.png`];
    const selfHelpImg6 = import.meta.glob("../../img/autoayuda/*/autoayuda-mapconfig-6.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-mapconfig-6.png`];


    const selfHelp = [
        {
            tab: 1, header: { text: t("selfHelp.instructions") }, params:
                [
                    { id: 0, text: t("selfHelp.mapconfig.msg0"), image: selfHelpImg0 },
                    { id: 1, text: t("selfHelp.mapconfig.msg1"), image: selfHelpImg1 },
                    { id: 2, text: t("selfHelp.mapconfig.msg2"), image: selfHelpImg2 },
                    { id: 3, text: t("selfHelp.mapconfig.msg3"), image: selfHelpImg3 },
                    { id: 4, text: t("selfHelp.mapconfig.msg4"), image: selfHelpImg4 },
                    { id: 5, text: t("selfHelp.mapconfig.msg5"), image: selfHelpImg5 },
                    { id: 6, text: t("selfHelp.mapconfig.msg6"), image: selfHelpImg6 },
                ]
        }
    ];

    useEffect(() => {
        if (uploadedMap != null) {
            setDataLoading(true);
            let index = 1;
            const geometry = [];
            const points = [];
            for (const feature of uploadedMap.features) {
                if (feature.geometry.type === "Polygon") {
                    const newPol = { id: index, nombre: feature.properties.name, path: [] };
                    index++;
                    for (let i = 0; i < feature.geometry.coordinates[0].length - 1; i++) {
                        const point = feature.geometry.coordinates[0][i];
                        newPol.path.push({
                            lat: point[1],
                            lng: point[0]
                        });
                    }
                    const sectorBounds = new window.google.maps.LatLngBounds();
                    newPol.path.forEach((point) => {
                        sectorBounds.extend(point);
                    });
                    newPol.bounds = { southWest: sectorBounds.getSouthWest().toJSON(), northEast: sectorBounds.getNorthEast().toJSON() };
                    geometry.push(newPol);
                } else if (feature.geometry.type === "Point") {
                    const newPnt = {
                        id: index,
                        nombre: feature.properties.name,
                        path: {
                            lat: feature.geometry.coordinates[1],
                            lng: feature.geometry.coordinates[0],
                        }
                    };
                    points.push(newPnt);
                    index++;
                }
            }
            if (geometry.length === 0 && points.length === 0) {
                toast.error(t("mapconfig.errorArchivoVacio"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                if(document?.getElementById?.("uploadKMZ")?.value){
                    document.getElementById("uploadKMZ").value = null;
                }
                setUploadedMap(null);
            } else {
                setPoligonosMarkers({
                    polygons: geometry,
                    points: points
                });
                setPoligonosList([{ id: 0, nombre: null }].concat(geometry));
                setPuntosList([{ id: 0, nombre: null }].concat(points));
            }
            setDataLoading(false);
        } else {
            setPoligonosMarkers(null);
            setPoligonosList(null);
            setPuntosList(null);
        }

    }, [uploadedMap]);

    useEffect(() => {
        if (sectorsInfo && sectoresRows === null && mapaJson) {
            const rows = [];
            let key = -1;
            if (sectoresRows !== null) {
                for (const s of sectoresRows) {
                    if (s.key > key) {
                        key = s.key;
                    }
                }
            }

            for (const sector of sectorsInfo) {
                const sectorCoord = mapaJson?.sectores?.[sector.sector_id] ? mapaJson.sectores[sector.sector_id] : null;
                key++;
                const obj = {
                    key: key,
                    sector_id: sector.sector_id,
                    nombre: sector.nombre,
                    originalPol: (sectorCoord !== undefined && sectorCoord !== null) ? sectorCoord : null,
                    polygon: null,
                    reAssign: false
                };
                rows.push(obj);
            }

            setSectoresRows(rows);

        }
    }, [sectorsInfo, mapaJson, sectoresRows]);

    useEffect(() => {
        if (mapaJson === null) {
            const mapa_json = JSON.parse(JSON.stringify(dispatch({ type: "get", path: "mapa_json" })));
            if (mapa_json !== null) setMapaJson(mapa_json);
            else setMapaJson({});

        }

    }, [mapaJson]);


    useEffect(() => {
        if (nodesInfo !== null && nodosRows === null && mapaJson !== null) {
            const rows = [];
            let key = -1;
            if (nodosRows !== null) {
                for (const s of nodosRows) {
                    if (s.key > key) {
                        key = s.key;
                    }
                }
            }

            for (const nodo of nodesInfo) {
                if ([1, 2, 7, 8, 9, 10,16].includes(nodo.tipo)) {
                    const nodoCoord = mapaJson?.nodos?.[nodo.nodo_id] ? mapaJson.nodos[nodo.nodo_id] : null;
                    key++;
                    const obj = {
                        key: key,
                        nodo_id: nodo.nodo_id,
                        nombre: nodo.nombre,
                        originalPnt: (nodoCoord !== undefined && nodoCoord !== null) ? nodoCoord : null,
                        point: null,
                        reAssign: false
                    };
                    rows.push(obj);
                }
            }

            setNodosRows(rows);

        }
    }, [nodesInfo, mapaJson, nodosRows]);

    useEffect(() => {
        if (nodosRows !== null) setPagNodosRows(nodosRows.slice((pagNodos * maxRows) - maxRows, (pagNodos * maxRows)));
    }, [pagNodos, nodosRows, maxRows]);

    useEffect(() => {
        if (sectoresRows !== null) setPagSectoresRows(sectoresRows.slice((pagSectores * maxRows) - maxRows, (pagSectores * maxRows)));
    }, [pagSectores, sectoresRows, maxRows]);

    const deleteFile = () => {
        setUploadedMap(null);
        setMapaJson(null);
        setPoligonosList(null);
        setPoligonosMarkers(null);
        setPuntosList(null);
        setFileName(null);
        setSectoresRows(null);
        setNodosRows(null);
        /*setSectoresRows(() =>
            sectoresRows.map(s => {
                return {...s, polygon: null, reAssign: false};
            })
        )
        setNodosRows(() =>
            nodosRows.map(n => {
                return {...n, point: null, reAssign: false};
            })
        ) */
    };

    const onUpload = async (args) => {
        let file = args.target.files[0];
        const name = file.name;
        const value = args.target.value;
        if (file !== undefined) {
            const fileFormat = file.name.split(".").slice(-1)[0].toLowerCase();
            if (fileFormat === "kml") {
                // do nothing
            } else if (fileFormat === "kmz") {
                const fileContent = await jszip.loadAsync(file);
                file = await fileContent.files["doc.kml"].async("blob").then(function (fileData) {
                    return new File([fileData], "doc.kml");
                });
            } else {
                document.getElementById("uploadKMZ").value = null;
                file = null;
            }

            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    const geoJson = kmlParser.toGeoJson(reader.result);
                    setUploadedMap(geoJson);
                    setFileName(name);
                };
                reader.readAsText(file);
            }
        }
    };

    const updateSectoresRows = (sector, updateMap) => {
        setSectoresRows(sectoresRows.map((row, id) => {
            if (row.sector_id === sector.sector_id) {
                return sector;
            }
            return row;
        }));

        if (updateMap) {
            const _mapaJson = mapaJson;
            if (sector.originalPol !== null) {
                if (sector.reAssign) {
                    delete _mapaJson.sectores[sector.sector_id];
                } else {
                    _mapaJson.sectores[sector.sector_id] = sector.originalPol;
                }
                setMapaJson(_mapaJson);
            }
        }
    };

    const updateNodosRows = (nodo, updateMap) => {
        setNodosRows(nodosRows.map((row, id) => {
            if (row.nodo_id === nodo.nodo_id) {
                return nodo;
            }
            return row;
        }));

        if (updateMap) {
            const _mapaJson = mapaJson;
            if (nodo.originalPnt !== null) {
                if (nodo.reAssign) {
                    delete _mapaJson.nodos[nodo.nodo_id];
                } else {
                    _mapaJson.nodos[nodo.nodo_id] = nodo.originalPnt;
                }
                setMapaJson(_mapaJson);
            }
        }
    };

    const centerOnPolygon = (pol) => {
        /*
        let bounds = new window.google.maps.LatLngBounds();
        if (pol.polygon !== null) {
            pol.polygon.path.forEach((p) => {
                bounds.extend(new window.google.maps.LatLng(p.lat, p.lng))
            })
        } else if (pol.originalPol !== null) {
            pol.originalPol.path.forEach((p) => {
                bounds.extend(new window.google.maps.LatLng(p.lat, p.lng))
            })
        }
        let center = bounds.getCenter().toJSON();
        mapRef.current.setCenter({ lat: center.lat, lng: center.lng });*/
        const bounds = new window.google.maps.LatLngBounds();
        if (pol.polygon !== null) {
            mapRef.current.setSelected(`unasigned-${pol.polygon.id}`);
            pol.polygon.path.forEach((p) => {
                bounds.extend(new window.google.maps.LatLng(p.lat, p.lng));
            });
            const center = bounds.getCenter().toJSON();
            mapRef.current.setCenter({ lat: center.lat, lng: center.lng });
        } else if (pol.originalPol !== null && !pol.reAssign) {
            mapRef.current.setSelected(`sector-${pol.sector_id}`);
            pol.originalPol.path.forEach((p) => {
                bounds.extend(new window.google.maps.LatLng(p.lat, p.lng));
            });
            const center = bounds.getCenter().toJSON();
            mapRef.current.setCenter({ lat: center.lat, lng: center.lng });
        } else {
            mapRef.current.setSelected();
        }
    };

    const centerOnPoint = (pnt) => {
        /*
        if (pnt.point !== null) {
            mapRef.current.setCenter({ lat: pnt.point.lat, lng: pnt.point.lng });
        } else if (pnt.originalPnt !== null) {
            mapRef.current.setCenter({ lat: pnt.originalPnt.lat, lng: pnt.originalPnt.lng });
        }*/
        if (pnt.point !== null) {
            mapRef.current.setSelected(`unasigned-${pnt.point.id}`);
            mapRef.current.setCenter({ lat: pnt.point.path.lat, lng: pnt.point.path.lng });
        } else if (pnt.originalPnt !== null && !pnt.reAssign) {
            mapRef.current.setSelected(`nodo-${pnt.nodo_id}`);
            mapRef.current.setCenter({ lat: pnt.originalPnt.lat, lng: pnt.originalPnt.lng });
        } else {
            mapRef.current.setSelected();
        }
    };

    const updateMap = async () => {
        setDataLoading(true);
        try {

            const values = { isModified: true };
            const bounds = new window.google.maps.LatLngBounds();
            const updatedSectoresRows = [];
            const updatedNodosRows = [];

            for (const s of sectoresRows) {
                if (s.polygon !== null) {
                    updatedSectoresRows.push(s);
                    s.polygon.path.forEach((p) => {
                        bounds.extend(new window.google.maps.LatLng(p.lat, p.lng));
                    });
                } else if (s.originalPol !== null) {
                    if (s.reAssign) {
                        updatedSectoresRows.push(s);
                    } else {
                        s.originalPol.path.forEach((p) => {
                            bounds.extend(new window.google.maps.LatLng(p.lat, p.lng));
                        });
                    }
                }
            }

            for (const n of nodosRows) {
                if (n.point !== null) {
                    updatedNodosRows.push(n);
                    bounds.extend(new window.google.maps.LatLng(n.point.path.lat, n.point.path.lng));
                } else if (n.originalPnt !== null) {
                    if (n.reAssign) {
                        updatedNodosRows.push(n);
                    } else {
                        bounds.extend(new window.google.maps.LatLng(n.originalPnt.lat, n.originalPnt.lng));
                    }
                }
            }

            if (updatedNodosRows.length === 0 && updatedSectoresRows.length === 0) {
                toast.info(t("forms.toastInfo"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                deleteFile();
                setDataLoading(false);
                return;
            }

            if (updatedNodosRows.length > 0) {
                values.nodos = {};
                for (const n of updatedNodosRows) {
                    if (n.point !== null) {
                        values.nodos[n.nodo_id] = { lat: n.point.path.lat, lng: n.point.path.lng };
                    } else if (n.originalPnt !== null && n.reAssign) values.nodos[n.nodo_id] = null;
                }
            }

            if (updatedSectoresRows.length > 0) {
                values.sectores = {};
                for (const s of updatedSectoresRows) {
                    if (s.polygon !== null) {
                        values.sectores[s.sector_id] = { path: s.polygon.path, bounds: s.polygon.bounds };
                    } else if (s.originalPol !== null && s.reAssign) {
                        values.sectores[s.sector_id] = null;
                    }
                }
            }

            values.position = bounds.getCenter().toJSON();
            values.bounds = { southWest: bounds.getSouthWest().toJSON(), northEast: bounds.getNorthEast().toJSON() };
            values.zoom = mapRef.current.getMapInfo({}).zoom;

            const success = await updateMapInfo(farmId, values, t, dispatch);

            if (success) {
                deleteFile();
                toast.success(t("mapconfig.success"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                if (!visibleMap) toast.warning(t("maps.mapaNoVisibleTip"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
            }
        } catch (err) {
            toast.error(t("mapconfig.error"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
        }
        setDataLoading(false);
    };

    const increasePag = () => {
        if (showSectoresTab) {
            if (pagSectores < Math.ceil(sectoresRows.length / maxRows)) setPagSectores(pagSectores + 1);
        } else {
            if (pagNodos < Math.ceil(nodosRows.length / maxRows)) setPagNodos(pagNodos + 1);
        }

    };

    const decreasePag = () => {
        if (showSectoresTab) {
            if (pagSectores > 1) setPagSectores(pagSectores - 1);
        } else {
            if (pagNodos > 1) setPagNodos(pagNodos - 1);
        }
    };

    const changeNumRows = (e) => {
        setPagSectores(1);
        setPagNodos(1);
        setMaxRows(e.value);
    };

    return (
        <div className='row-container'>
            {dataLoading && <LoadingDialog />}
            <div className='row'>
                <div className="col-xl-6 col-lg-12 col-sm-12" >
                    <div className="card">
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-2'>
                                    {selfHelp &&
                                        <SelfHelp t={t} lng={i18n.language} params={selfHelp} fertiTable />}
                                </div>
                                <div className='col col-sm-8 col-md-6 col-lg-8 text-center'>
                                    <h5 className="card-title">
                                        <span>{t("mapconfig.sectores_nodos")}</span>
                                    </h5>
                                </div>
                                <div className='col col-sm-2 col-md-3 col-lg-2 d-flex justify-content-end align-items-center'>
                                    {/*
                                    <TooltipPrime id="toolDownload"  content={t("downloadTooltip")} position="bottom">
                                        <FontAwesomeIcon className='pointer' onClick={() => redirectToMapaConfig()} size="2x" icon={faCog} style={{ color: 'lightblue' }}></FontAwesomeIcon>
                                    </TooltipPrime>*/}
                                </div>
                            </div>
                            <div className='linea-titulo' />
                            <div className='row align-items-center'>
                                <div className='col col-sm-1 col-md-4 e-btn-group'>
                                    <input type="checkbox" readOnly id="sectoresTab" checked={showSectoresTab} onClick={() => {
                                        setShowSectoresTab(true);
                                        setShowNodosTab(false);
                                    }}
                                    />
                                    <label className="button-tab" htmlFor="sectoresTab">{t("farms.zonesTable.title")}</label>
                                    <input type="checkbox" readOnly id="nodosTab" checked={showNodosTab} onClick={() => {
                                        setShowSectoresTab(false);
                                        setShowNodosTab(true);
                                    }}
                                    />
                                    <label className="button-tab" htmlFor="nodosTab">{t("farms.nodesTable.title")}</label>
                                </div>
                                <div className='col col-sm-4 col-md-8 text-right'>
                                    {uploadedMap ?
                                        <div>
                                            <FontAwesomeIcon size="lg" style={{ color: "red" }} icon={faTrashAlt} title="eliminar" onClick={() => deleteFile()} />
                                            {/*<FontAwesomeIcon size="lg" style={{ color: "green" }} icon={faCheckCircle}></FontAwesomeIcon>*/}
                                            <span style={{ paddingLeft: "10px" }}>{fileName}</span>
                                        </div>
                                        : <div>
                                            <label htmlFor='uploadKMZ' className="custom-file-upload">
                                                {t("mapconfig.subirArchivo")}
                                            </label>
                                            <input id='uploadKMZ'
                                                type='file'
                                                accept=".kml,.kmz"
                                                onChange={(event) => onUpload(event)}
                                                className='input-file-invisible'
                                            />
                                        </div>}
                                </div>
                            </div>

                            {showSectoresTab && <div className='row row-header'>
                                <div className='col col-sm-2 col-md-3 col-lg-2' />
                                <div className='col col-sm-2 col-md-3 col-lg-8 text-center'>
                                    <h6 className='row-header-text'>{t("farms.zonesTable.title")}</h6>
                                </div>
                                <div className='col col-sm-2 col-md-3 col-lg-2' />
                            </div>}
                            {showSectoresTab && sectoresRows && pagSectoresRows && pagSectoresRows.map((s) => (
                                <div key={s.key}>
                                    <ZonesMapTableRow
                                        data={s}
                                        sectorsInfo={sectorsInfo}
                                        poligonosList={poligonosList}
                                        dataFarm={dataFarm}
                                        update={updateSectoresRows}
                                        center={centerOnPolygon}
                                        fileUploaded={uploadedMap !== null}
                                    />
                                    <div className='linea-table' />
                                </div>
                            ))}

                            {showNodosTab && <div className='row row-header'>
                                <div className='col col-sm-2 col-md-3 col-lg-2' />
                                <div className='col col-sm-2 col-md-3 col-lg-8 text-center'>
                                    <h6 className='row-header-text'>{t("farms.nodesTable.title")}</h6>
                                </div>
                                <div className='col col-sm-2 col-md-3 col-lg-2' />
                            </div>}
                            {showNodosTab && nodosRows && pagNodosRows && pagNodosRows.map((s) => (
                                <div key={s.key}>
                                    <NodesMapTableRow
                                        data={s}
                                        nodesInfo={nodesInfo}
                                        puntosList={puntosList}
                                        dataFarm={dataFarm}
                                        update={updateNodosRows}
                                        center={centerOnPoint}
                                        fileUploaded={uploadedMap !== null}
                                    />
                                    <div className='linea-table' />
                                </div>
                            ))}
                            <br />
                            <div className='row'>
                                <div className='col col-sm-2 col-md-4 col-lg-4 align-items-left'>
                                    {uploadedMap &&
                                        <div className='row align-items-center'>
                                            <div className='col' style={{paddingRight: "5px"}}>
                                                <ButtonPrime label={t("forms.save")} onClick={updateMap} />
                                            </div>
                                            <div className='col' style={{paddingLeft: "0px"}}>
                                                {!visibleMap &&
                                                    <TooltipPrime id="toolSelfHelp-MapConfig"  content={t("maps.mapaNoVisibleTip")} position="right">
                                                        <FontAwesomeIcon size="lg" style={{ color: "orange" }} icon={faExclamationTriangle} />
                                                    </TooltipPrime>}
                                            </div>
                                        </div>}
                                </div>
                                <div className='col col-sm-2 col-md-4 col-lg-4 text-center justify-content-end align-items-center '>
                                    <div className='row line-height-40'>
                                        <div className='col'>
                                            {showNodosTab ? pagNodos > 1 && <FontAwesomeIcon size="lg" style={{ color: "grey" }} icon={faArrowCircleLeft} title="eliminar" onClick={() => decreasePag()} />
                                                : showSectoresTab ? pagSectores > 1 && <FontAwesomeIcon size="lg" style={{ color: "grey" }} icon={faArrowCircleLeft} title="eliminar" onClick={() => decreasePag()} />
                                                    : null}
                                        </div>
                                        <div className='col'>
                                            <span>{showNodosTab && nodosRows ? `${pagNodos}/${Math.ceil(nodosRows.length / maxRows)}` : showSectoresTab && sectoresRows ? `${pagSectores}/${Math.ceil(sectoresRows.length / maxRows)}` : "1/1"}</span>
                                        </div>
                                        <div className='col'>
                                            {nodosRows && showNodosTab ? pagNodos < Math.ceil(nodosRows.length / maxRows) && <FontAwesomeIcon size="lg" style={{ color: "grey" }} icon={faArrowCircleRight} title="eliminar" onClick={() => increasePag()} />
                                                : sectoresRows && showSectoresTab ? pagSectores < Math.ceil(sectoresRows.length / maxRows) && <FontAwesomeIcon size="lg" style={{ color: "grey" }} icon={faArrowCircleRight} title="eliminar" onClick={() => increasePag()} />
                                                    : null}
                                        </div>
                                    </div>
                                </div>
                                <div className='col col-sm-2 col-md-4 col-lg-4 d-flex justify-content-end align-items-center'>
                                    <span className='line-height-40' style={{ paddingRight: "10px" }}>{t("mapconfig.numRows")}</span>
                                    <DropdownPrime
                                        filter={false}
                                        style={{maxWidth:"90px"}}
                                        value={maxRows}
                                        onChange={(e) => { changeNumRows(e); }}
                                        options={numRows} optionLabel="num"
                                        optionValue="num"
                                        name="max_rows"
                                        showClear={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-12 col-sm-12 map-col">
                    <div className="card">
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-2' />
                                <div className='col col-sm-8 col-md-6 col-lg-8 text-center'>
                                    <h5 className="card-title">
                                        <span>{t("maps.map")}</span>
                                    </h5>
                                </div>
                                <div className='col col-sm-2 col-md-3 col-lg-2 d-flex justify-content-end ' />
                            </div>
                            <div className='linea-titulo' />
                            <div className='mapsWrapper'>
                                <GoogleMapsFarm
                                    apiKey="AIzaSyCvs7xPDh2vfmQO2w02lcItOXa6OKOVmQ4"
                                    data={mapaJson}
                                    farmId={dataFarm.campo_id}
                                    innerRef={mapRef}
                                    language={i18n.language}
                                    iconBorder={farmblack}
                                    husoHorario={dataFarm.huso_horario}
                                    unasigned={poligonosMarkers}
                                    notShowPolygons={!showSectoresTab}
                                    notShowPoints={!showNodosTab}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withName(MapaConfig, "MapaConfigFrag");
